<template>
    <div>
        <b-alert class="position-fixed fixed-top m-0 rounded-0 text-center" style="z-index: 2000;"
            :show="dismissCountDown"
            :variant="errorMessage.color"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged">

            {{ errorMessage.text }}

        </b-alert>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState(['errorMessage'])
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        }
    },
}
</script>